export default __webpack_public_path__ + "static/banner-5-things-you-need-to-have-before-you-consolidate-your-debt-8acf0463ed900a457940f5e51077f873.jpg";